import React from 'react'
import { t } from 'ttag'

import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'
import { IconButton } from 'components/shared/IconButton/IconButton'
import { useDepartmentListingTable } from './hooks'
import { Edit3Icon, Trash2Icon } from 'components/shared/Icon/model'
import { PrimaryCell } from 'components/shared/Table/common/Cells/PrimaryCell/PrimaryCell'
import styles from './DepartmentListingTable.module.scss'
import { toDepartments } from 'ducks/router'

const mapSortingPropToQueryParam = {
  projects_count: 'projects_count',
  name: 'name',
  users_count: 'users_count',
  created_at: 'created_at',
}

export const DepartmentListingTable = ({
  search,
  handleDelete,
  handleEdit,
  handleDeleteDepartmentWarningOpen,
}) => {
  const { state, handlers } = useDepartmentListingTable({
    mapSortingPropToQueryParam,
    search,
  })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table className={styles.table}>
        <Table.Head>
          <Table.Row>
            {headers.map(
              ({ columnDef, getToggleSortingHandler, getIsSorted }, index) => {
                const { accessorKey, header, alignLeft } = columnDef

                return (
                  <HeaderCell
                    key={header}
                    alignLeft={!!alignLeft}
                    sortType={getIsSorted()}
                    text={header}
                    onClick={getToggleSortingHandler()}
                    hasSorting={accessorKey}
                  />
                )
              },
            )}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{ title: t`No departments available` }}
          isLoaded={!isFetching}
        >
          {model.rows.map(({ id, original }) => {
            const { projects_count, name, users_count, created_at } = original

            return (
              <Table.Row key={id}>
                <PrimaryCell primary={name} to={toDepartments(id)} />
                <TextCell text={users_count} />
                <TextCell text={projects_count} />
                <DateCell date={created_at} />
                <ActionsCell>
                  <IconButton
                    icon={Edit3Icon}
                    size="medium"
                    ariaLabel="edit"
                    variant="text"
                    onClick={() => handleEdit(original)}
                  />
                  <IconButton
                    icon={Trash2Icon}
                    size="medium"
                    variant="text"
                    onClick={
                      projects_count
                        ? handleDeleteDepartmentWarningOpen
                        : () => handleDelete(original)
                    }
                  />
                </ActionsCell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
